import { useMemo } from "react";

import AuthenticationContext from "common/auth/AuthenticationContext";
import { useBuildNext, useCurrentNext } from "common/router/hooks";

import { INITIAL_CLIENT_DATA } from "client/common/utils";
import Protected from "client/common/components/auth/Protected";
import { urls } from "client/routes";

const { is_authenticated: isAuthenticated } = INITIAL_CLIENT_DATA;

type CheckoutAuthenticationProviderProps = { children: React.ReactElement };

const CheckoutAuthenticationProvider = ({ children }: CheckoutAuthenticationProviderProps) => {
  const buildNext = useBuildNext();
  // After signup, return clients to the checkout page they came from (keeping the
  // cart's query params) instead of the storefront home page.
  const signupNext = useCurrentNext();

  const authValue = useMemo(
    () => ({
      // we don't have to worry about this changing because we will always refresh on login
      // (and re-generate this value from the BE)
      isAuthenticated,
      onUnauthenticated: () => {
        const flash = "Your session has timed out, please enter the same phone-number to continue.";
        const next = buildNext(urls.home.root());
        // hard load auth page to refetch any failed queries
        window.location.replace(buildNext(urls.accounts.lookup({ search: { next, flash } })));
      },
    }),
    [buildNext],
  );

  return (
    <AuthenticationContext.Provider value={authValue}>
      <Protected next={signupNext}>{children}</Protected>
    </AuthenticationContext.Provider>
  );
};

export default CheckoutAuthenticationProvider;
